module.exports = __webpack_public_path__ + "static/media/S-1-Y.9717986c.mp3";